import { environment } from "src/environments/environment";


export function overrideConsoleLogs(): void {
  if (!environment.enableConsoleLogs) {
    console.log = () => {};
  }
}
